import React from 'react';
import { useSessionTimeoutMutation } from './api/useSessionTimeoutMutation';
import { ModalHeader } from '../CommonComponents/OPL/Modal/ModalHeader';
import { ModalBody } from '../CommonComponents/OPL/Modal/ModalBody';
import { Modal } from '../CommonComponents/OPL/Modal/Modal';
import { ModalFooter } from '../CommonComponents/OPL/Modal/ModalFooter';
import { Button } from '../CommonComponents/OPL/Button/Button';
import { Text } from '../CommonComponents/OPL/Text/Text';
import { Alert } from '../CommonComponents/OPL/Alert/Alert';

interface Props {
  onClose(): void;
}

export const SessionTimeoutModal: React.FC<Props> = ({ onClose }) => {
  const { mutateAsync: extendSessionTimeout, isLoading, error } = useSessionTimeoutMutation();

  const handleExtendSessionTimeout = async () => {
    try {
      await extendSessionTimeout();

      onClose();
      ADV.util.SessionTimeout.extendTimer();
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <Modal
      isOpen
      onRequestClose={onClose}
      aria={{
        labelledby: 'session-timeout-modal-heading',
        describedby: 'session-timeout-modal-description',
      }}
      shouldCloseOnOverlayClick={false}
    >
      <ModalHeader id="session-timeout-modal-heading">Session Timeout</ModalHeader>
      <ModalBody id="session-timeout-modal-description">
        {error && <Alert message={error.message} variant="error" mb="16" />}

        <Text>
          Your session is about to time out for security reasons. Would you like to remain logged
          in?
        </Text>
      </ModalBody>

      <ModalFooter>
        <Button mr="8" variant="secondary" onClick={() => ADV.Controller.logout(true)}>
          Sign me out
        </Button>

        <Button onClick={handleExtendSessionTimeout} isLoading={isLoading}>
          Keep me logged in
        </Button>
      </ModalFooter>
    </Modal>
  );
};
